/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DeleteUserVerificationRequest,
    DeleteUserVerificationRequestFromJSON,
    DeleteUserVerificationRequestToJSON,
} from '../models/DeleteUserVerificationRequest';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type IsUserIdPortenValidatedResponse,
    IsUserIdPortenValidatedResponseFromJSON,
    IsUserIdPortenValidatedResponseToJSON,
} from '../models/IsUserIdPortenValidatedResponse';
import {
    type NameChangeRequest,
    NameChangeRequestFromJSON,
    NameChangeRequestToJSON,
} from '../models/NameChangeRequest';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type UpdateUserPreferredLanguageRequest,
    UpdateUserPreferredLanguageRequestFromJSON,
    UpdateUserPreferredLanguageRequestToJSON,
} from '../models/UpdateUserPreferredLanguageRequest';
import {
    type UserAccessResponse,
    UserAccessResponseFromJSON,
    UserAccessResponseToJSON,
} from '../models/UserAccessResponse';
import {
    type UserEventResponse,
    UserEventResponseFromJSON,
    UserEventResponseToJSON,
} from '../models/UserEventResponse';
import {
    type UserPreferredLanguageResponse,
    UserPreferredLanguageResponseFromJSON,
    UserPreferredLanguageResponseToJSON,
} from '../models/UserPreferredLanguageResponse';
import {
    type UserProfileResponse,
    UserProfileResponseFromJSON,
    UserProfileResponseToJSON,
} from '../models/UserProfileResponse';
import {
    type VerifiedUserResponse,
    VerifiedUserResponseFromJSON,
    VerifiedUserResponseToJSON,
} from '../models/VerifiedUserResponse';
import {
    type VerifyUserRequest,
    VerifyUserRequestFromJSON,
    VerifyUserRequestToJSON,
} from '../models/VerifyUserRequest';
import {
    type VerifyUserResponse,
    VerifyUserResponseFromJSON,
    VerifyUserResponseToJSON,
} from '../models/VerifyUserResponse';

export interface ApiProfileCurrentPreferredLanguagePutRequest {
    updateUserPreferredLanguageRequest: UpdateUserPreferredLanguageRequest;
}

export interface ApiProfileNamePutRequest {
    nameChangeRequest: NameChangeRequest;
}

export interface ApiProfilePermissionsPermissionIdDeleteRequest {
    permissionId: number;
}

export interface ApiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequest {
    permissionId: number;
    organizationId: number;
}

export interface ApiProfileRolesRoleIdDeleteRequest {
    roleId: number;
}

export interface ApiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequest {
    roleId: number;
    organizationId: number;
}

export interface ApiProfileUserVerificationDeleteRequest {
    deleteUserVerificationRequest: DeleteUserVerificationRequest;
}

export interface ApiProfileUserVerificationPostRequest {
    verifyUserRequest: VerifyUserRequest;
}

export interface ApiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequest {
    verifyUserRequest: VerifyUserRequest;
}

/**
 * 
 */
export class ProfileApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiProfileConsentsGet without sending the request
     */
    async apiProfileConsentsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/consents`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileConsentsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEventResponse>>> {
        const requestOptions = await this.apiProfileConsentsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEventResponseFromJSON));
    }

    /**
     */
    async apiProfileConsentsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEventResponse>> {
        const response = await this.apiProfileConsentsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileCurrentGet without sending the request
     */
    async apiProfileCurrentGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/current`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileCurrentGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserProfileResponse>> {
        const requestOptions = await this.apiProfileCurrentGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileCurrentGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserProfileResponse> {
        const response = await this.apiProfileCurrentGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileCurrentPermissionsGet without sending the request
     */
    async apiProfileCurrentPermissionsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/current-permissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileCurrentPermissionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserAccessResponse>>> {
        const requestOptions = await this.apiProfileCurrentPermissionsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserAccessResponseFromJSON));
    }

    /**
     */
    async apiProfileCurrentPermissionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserAccessResponse>> {
        const response = await this.apiProfileCurrentPermissionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileCurrentPreferredLanguageGet without sending the request
     */
    async apiProfileCurrentPreferredLanguageGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/current/preferred-language`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileCurrentPreferredLanguageGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPreferredLanguageResponse>> {
        const requestOptions = await this.apiProfileCurrentPreferredLanguageGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferredLanguageResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileCurrentPreferredLanguageGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPreferredLanguageResponse> {
        const response = await this.apiProfileCurrentPreferredLanguageGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileCurrentPreferredLanguagePut without sending the request
     */
    async apiProfileCurrentPreferredLanguagePutRequestOpts(requestParameters: ApiProfileCurrentPreferredLanguagePutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateUserPreferredLanguageRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserPreferredLanguageRequest',
                'Required parameter "updateUserPreferredLanguageRequest" was null or undefined when calling apiProfileCurrentPreferredLanguagePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/profile/current/preferred-language`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserPreferredLanguageRequestToJSON(requestParameters['updateUserPreferredLanguageRequest']),
        };
    }

    /**
     */
    async apiProfileCurrentPreferredLanguagePutRaw(requestParameters: ApiProfileCurrentPreferredLanguagePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPreferredLanguageResponse>> {
        const requestOptions = await this.apiProfileCurrentPreferredLanguagePutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferredLanguageResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileCurrentPreferredLanguagePut(requestParameters: ApiProfileCurrentPreferredLanguagePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPreferredLanguageResponse> {
        const response = await this.apiProfileCurrentPreferredLanguagePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileEventsGet without sending the request
     */
    async apiProfileEventsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/events`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileEventsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEventResponse>>> {
        const requestOptions = await this.apiProfileEventsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEventResponseFromJSON));
    }

    /**
     */
    async apiProfileEventsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEventResponse>> {
        const response = await this.apiProfileEventsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileNamePut without sending the request
     */
    async apiProfileNamePutRequestOpts(requestParameters: ApiProfileNamePutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nameChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'nameChangeRequest',
                'Required parameter "nameChangeRequest" was null or undefined when calling apiProfileNamePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/profile/name`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NameChangeRequestToJSON(requestParameters['nameChangeRequest']),
        };
    }

    /**
     */
    async apiProfileNamePutRaw(requestParameters: ApiProfileNamePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserProfileResponse>> {
        const requestOptions = await this.apiProfileNamePutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileNamePut(requestParameters: ApiProfileNamePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserProfileResponse> {
        const response = await this.apiProfileNamePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfilePermissionsPermissionIdDelete without sending the request
     */
    async apiProfilePermissionsPermissionIdDeleteRequestOpts(requestParameters: ApiProfilePermissionsPermissionIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiProfilePermissionsPermissionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/permissions/{permissionId}`;
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfilePermissionsPermissionIdDeleteRaw(requestParameters: ApiProfilePermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiProfilePermissionsPermissionIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProfilePermissionsPermissionIdDelete(requestParameters: ApiProfilePermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiProfilePermissionsPermissionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiProfilePermissionsPermissionIdOrganizationOrganizationIdDelete without sending the request
     */
    async apiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: ApiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiProfilePermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling apiProfilePermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/permissions/{permissionId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters: ApiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProfilePermissionsPermissionIdOrganizationOrganizationIdDelete(requestParameters: ApiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiProfilePermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiProfileRolesRoleIdDelete without sending the request
     */
    async apiProfileRolesRoleIdDeleteRequestOpts(requestParameters: ApiProfileRolesRoleIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiProfileRolesRoleIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/roles/{roleId}`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileRolesRoleIdDeleteRaw(requestParameters: ApiProfileRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiProfileRolesRoleIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProfileRolesRoleIdDelete(requestParameters: ApiProfileRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiProfileRolesRoleIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiProfileRolesRoleIdOrganizationOrganizationIdDelete without sending the request
     */
    async apiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: ApiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiProfileRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling apiProfileRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/roles/{roleId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters: ApiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProfileRolesRoleIdOrganizationOrganizationIdDelete(requestParameters: ApiProfileRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiProfileRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiProfileUserVerificationDelete without sending the request
     */
    async apiProfileUserVerificationDeleteRequestOpts(requestParameters: ApiProfileUserVerificationDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deleteUserVerificationRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteUserVerificationRequest',
                'Required parameter "deleteUserVerificationRequest" was null or undefined when calling apiProfileUserVerificationDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/profile/user-verification`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteUserVerificationRequestToJSON(requestParameters['deleteUserVerificationRequest']),
        };
    }

    /**
     */
    async apiProfileUserVerificationDeleteRaw(requestParameters: ApiProfileUserVerificationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyUserResponse>> {
        const requestOptions = await this.apiProfileUserVerificationDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileUserVerificationDelete(requestParameters: ApiProfileUserVerificationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyUserResponse> {
        const response = await this.apiProfileUserVerificationDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileUserVerificationGet without sending the request
     */
    async apiProfileUserVerificationGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/profile/user-verification`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiProfileUserVerificationGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IsUserIdPortenValidatedResponse>> {
        const requestOptions = await this.apiProfileUserVerificationGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IsUserIdPortenValidatedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileUserVerificationGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IsUserIdPortenValidatedResponse> {
        const response = await this.apiProfileUserVerificationGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileUserVerificationPost without sending the request
     */
    async apiProfileUserVerificationPostRequestOpts(requestParameters: ApiProfileUserVerificationPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['verifyUserRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyUserRequest',
                'Required parameter "verifyUserRequest" was null or undefined when calling apiProfileUserVerificationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/profile/user-verification`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyUserRequestToJSON(requestParameters['verifyUserRequest']),
        };
    }

    /**
     */
    async apiProfileUserVerificationPostRaw(requestParameters: ApiProfileUserVerificationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyUserResponse>> {
        const requestOptions = await this.apiProfileUserVerificationPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiProfileUserVerificationPost(requestParameters: ApiProfileUserVerificationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyUserResponse> {
        const response = await this.apiProfileUserVerificationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiProfileUserVerificationReplaceableVerifiedUsersSearchesPost without sending the request
     */
    async apiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequestOpts(requestParameters: ApiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['verifyUserRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyUserRequest',
                'Required parameter "verifyUserRequest" was null or undefined when calling apiProfileUserVerificationReplaceableVerifiedUsersSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/profile/user-verification/replaceable-verified-users-searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyUserRequestToJSON(requestParameters['verifyUserRequest']),
        };
    }

    /**
     */
    async apiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRaw(requestParameters: ApiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VerifiedUserResponse>>> {
        const requestOptions = await this.apiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VerifiedUserResponseFromJSON));
    }

    /**
     */
    async apiProfileUserVerificationReplaceableVerifiedUsersSearchesPost(requestParameters: ApiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VerifiedUserResponse>> {
        const response = await this.apiProfileUserVerificationReplaceableVerifiedUsersSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
